import { IntlShape } from "react-intl";

export type EditorMode = "wysiwyg" | "plain";

const STORAGE_KEYS = {
  editorMode: "aqora_editor_mode",
};

export const setEditorMode = (mode: EditorMode) =>
  localStorage.setItem(STORAGE_KEYS["editorMode"], mode);

export const getEditorMode = (): EditorMode =>
  (localStorage.getItem(STORAGE_KEYS["editorMode"]) as EditorMode) || "wysiwyg";

export const formatEditorMode = (intl: IntlShape, mode: EditorMode) => {
  switch (mode) {
    case "wysiwyg":
      return intl.formatMessage({
        defaultMessage: "Switch to plain text editing",
      });
    case "plain":
      return intl.formatMessage({
        defaultMessage: "Switch to rich text editing",
      });
  }
};
